import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopAppBar from './TopAppBar';
import './MainLayout.css';

const MainLayout = ({ children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const handleMobileToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleToggleSidebar = () => {
        setSidebarCollapsed(!sidebarCollapsed);
    };

    return (
        <div className="main-layout">
            {/* Top App Bar */}
            <TopAppBar 
                onMobileMenuToggle={handleMobileToggle} 
                onToggleSidebar={handleToggleSidebar}
                sidebarCollapsed={sidebarCollapsed}
            />
            
            {/* Sidebar */}
            <Sidebar 
                mobileOpen={mobileOpen} 
                onMobileToggle={handleMobileToggle}
                collapsed={sidebarCollapsed}
                onToggleCollapse={handleToggleSidebar}
            />
            
            {/* Main Content */}
            <div className="main-content" style={{ 
                marginLeft: sidebarCollapsed ? '80px' : '280px',
            }}>
                <div className="main-content-inner">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MainLayout;